import React from 'react';
import Icon from '../../../components/AppIcon';

const ShoppingListItem = ({ item }) => {
  const getPriorityColor = (priority) => {
    switch(priority) {
      case 'critical': return 'text-destructive';
      case 'high': return 'text-warning';
      case 'medium': return 'text-secondary';
      default: return 'text-muted-foreground';
    }
  };

  const getPriorityBg = (priority) => {
    switch(priority) {
      case 'critical': return 'bg-destructive/10';
      case 'high': return 'bg-warning/10';
      case 'medium': return 'bg-secondary/10';
      default: return 'bg-muted';
    }
  };

  const getPriorityLabel = (priority) => {
    switch(priority) {
      case 'critical': return 'Critical';
      case 'high': return 'High';
      case 'medium': return 'Medium';
      default: return 'Low';
    }
  };

  const getPriorityIcon = (priority) => {
    switch(priority) {
      case 'critical': return 'AlertTriangle';
      case 'high': return 'TrendingUp';
      case 'medium': return 'Info';
      default: return 'Circle';
    }
  };

  const getCategoryIcon = (category) => {
    const icons = {
      Fresh: 'Leaf',
      Frozen: 'Snowflake',
      Canned: 'Package',
      Dry: 'Wheat',
      Snack: 'Cookie',
      Condiment: 'Droplet',
      Beverage: 'Coffee',
      Other: 'Box'
    };
    return icons?.[category] || 'Box';
  };

  return (
    <div className="p-4 hover:bg-muted/50 transition-colors duration-200">
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-3 flex-1 min-w-0">
          <div className="flex-shrink-0 mt-1">
            <Icon name={getCategoryIcon(item?.category)} size={20} className="text-muted-foreground" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-1">
              <h4 className="text-base font-medium text-foreground">{item?.name}</h4>
              <div className={`px-2 py-0.5 rounded-md ${getPriorityBg(item?.priority)} flex items-center gap-1`}>
                <Icon name={getPriorityIcon(item?.priority)} size={12} className={getPriorityColor(item?.priority)} />
                <span className={`text-xs font-medium ${getPriorityColor(item?.priority)}`}>
                  {getPriorityLabel(item?.priority)}
                </span>
              </div>
            </div>
            <p className="text-sm text-muted-foreground mb-3">{item?.category}</p>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
              <div>
                <span className="text-xs text-muted-foreground block mb-0.5">Current Stock</span>
                <span className="text-sm font-semibold text-foreground">
                  {item?.currentQuantity} {item?.unit}
                </span>
              </div>
              <div>
                <span className="text-xs text-muted-foreground block mb-0.5">Suggested Buy</span>
                <span className="text-sm font-semibold text-primary">
                  {item?.suggestedQuantity} {item?.unit}
                </span>
              </div>
              <div className="hidden md:block">
                <span className="text-xs text-muted-foreground block mb-0.5">Days Remaining</span>
                <span className={`text-sm font-semibold ${getPriorityColor(item?.priority)}`}>
                  {item?.daysRemaining} days
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShoppingListItem;